import { Fragment, type JSX } from 'react'

export type WordBreakProps = {
  delimiter: string
  children: string
}

/**
 * WordBreak a text at a specific string / character.
 * Useful to word break at specific delimiters like "/" where CSS options would
 * otherwise cause breaking at unwanted characters.
 */
export function WordBreak({
  children,
  delimiter,
}: WordBreakProps): JSX.Element {
  const parts = children.split(delimiter)

  return (
    <>
      {parts.map((part, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: No other possible key
        <Fragment key={`${delimiter}-${i}-${part}`}>
          {part}
          {i < parts.length - 1 && (
            <>
              /
              <wbr />
            </>
          )}
        </Fragment>
      ))}
    </>
  )
}
